import React from 'react';

import InputMask from 'react-input-mask'
import NumberFormat from "react-number-format";
import './index.scss';

const InputField = ({title, style, type, message, placeholder, max, min, valid, checked, value, maxLength, change = () => {}, full = false, checkedFunc = () => {}}) => {
    
    return (
        <div className="form-group">
            <label className={'calculator__control-label'}>{title}</label>
            {type === 'phone' ? (
                <InputMask
                    type="tel"
                    mask="+38 (099) 999-99-99"
                    placeholder={placeholder}
                    value={value}
                    onChange={({target: {value}}) => change(value)}
                    onBlur={() => checkedFunc()}
                />
            ) : (type === 'sum' ? (
                <NumberFormat 
                type={'text'}
                style={style}
                placeholder={placeholder}
                thousandSeparator={' '}
                maxLength={maxLength}
                min={min}
                max={max}
                onInput={(e) => {
                    if(isNaN(e.value)) {
                        e.target.value = e.target.value.replace(/\B(?=(\d{3})+(?!\d))/g, " ")
                    }
                }}
                value={value}
                onChange={({target: {value}}) => change(value)} 
                onBlur={() => checkedFunc()} 
                 />
            ) : (
                <input 
                type={type}
                style={style}
                placeholder={placeholder}
                value={value}
                onChange={({target: {value}}) => change(value)} 
                onBlur={() => checkedFunc()} 
                 />
            ))}
            
            {checked ? valid ? null : <p className='input-warning'>{message}</p> : null}
        </div>
    )
}

export default InputField;